import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Pricelist = lazy(() => import('./Pricelist'));

const PricelistRoute: FuseRouteItemType = {
    path: 'pricelist',
    element: <Pricelist />,
    settings: {
        layout: {
            config: {
                toolbar: {
                    title: 'Pricelist',
                }
            }
        }
    }
}

export default PricelistRoute;